import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7c6a0a06"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "publicSaleInfo" }
const _hoisted_2 = { class: "publicSaleInfo__header" }
const _hoisted_3 = { class: "publicSaleInfo__summary" }
const _hoisted_4 = { class: "publicSaleInfo__infoBlock green_background" }
const _hoisted_5 = { class: "publicSaleInfo__infoBlock" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Total Raise", -1 /* HOISTED */))
const _hoisted_7 = { class: "publicSaleInfo__infoBlock" }
const _hoisted_8 = {
  key: 0,
  class: "publicSaleInfo__dateText"
}
const _hoisted_9 = { class: "publicSaleInfo__infoBlock" }
const _hoisted_10 = {
  key: 0,
  class: "publicSaleInfo__dateText"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h3", _hoisted_2, _toDisplayString(_ctx.$t('BUY_TOKENS_VIEW.ROUND_INFO')) + " " + _toDisplayString($setup.usePublicSalesStore().roundInfo?.name), 1 /* TEXT */),
    _createCommentVNode("    <div style=\"width: 100%; height: 50px; padding: 0 20px;\">"),
    _createCommentVNode("      <PublicSalesBar v-if=\"parts && total\" :total=\"total\" :values=\"parts\"/>"),
    _createCommentVNode("    </div>"),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("span", null, _toDisplayString(_ctx.$t('BUY_TOKENS_VIEW.PRICE')), 1 /* TEXT */),
        _createElementVNode("span", null, "1 C4E = $" + _toDisplayString($setup.currency), 1 /* TEXT */)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createVNode($setup["CoinAmount"], {
          amount: $setup.total ? $setup.total : 0,
          "show-denom": true,
          precision: 2,
          "reduce-big-number": false
        }, null, 8 /* PROPS */, ["amount"])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("span", null, _toDisplayString(_ctx.$t('BUY_TOKENS_VIEW.TIME_TO_START')), 1 /* TEXT */),
        _createElementVNode("span", null, _toDisplayString($setup.timeToStart), 1 /* TEXT */),
        ($setup.startDate)
          ? (_openBlock(), _createElementBlock("span", _hoisted_8, "(" + _toDisplayString($setup.startDate.toUTCString()) + ")", 1 /* TEXT */))
          : _createCommentVNode("v-if", true)
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("span", null, _toDisplayString(_ctx.$t('BUY_TOKENS_VIEW.TIME_TO_END')), 1 /* TEXT */),
        _createElementVNode("span", null, _toDisplayString($setup.timeToEnd ? $setup.timeToEnd : 'The round has ended'), 1 /* TEXT */),
        ($setup.endDate)
          ? (_openBlock(), _createElementBlock("span", _hoisted_10, "(" + _toDisplayString($setup.endDate.toUTCString()) + ")", 1 /* TEXT */))
          : _createCommentVNode("v-if", true)
      ])
    ])
  ]))
}